module.exports = __webpack_public_path__ + "static/media/PM128.855b8b59.png";